import React from 'react';
import {Image} from "@chakra-ui/react";
import TailLoader from "../../../image/loader.svg";

const TailSpinLoader = ({isLoading = true, wrapperStyle}) => {
    return (<>
        {isLoading && <Image style={{...wrapperStyle}} src={TailLoader} alt="Loading spinner" />}
    </>);
};

export default TailSpinLoader;
